import { render } from "./CreateRedeem.vue?vue&type=template&id=047f80c2"
import script from "./CreateRedeem.vue?vue&type=script&lang=js"
export * from "./CreateRedeem.vue?vue&type=script&lang=js"

import "./CreateRedeem.vue?vue&type=style&index=0&id=047f80c2&lang=css"
script.render = render

export default script